function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 15 1.676 15 7.5 12.088 13.324 15 15 15 15 14.999 15 14.161 9.177 11.25 15 8.338 15 7.5 13.322 7.5 7.5 10.411 1.678 7.5 0 7.5 0 8.338 5.823 11.25 0 14.161 0 15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.117 15 7.5 11.809 13.883 15 15 15 15 14.999 15 14.44 8.617 11.25 15 8.059 15 7.5 13.881 7.5 7.5 10.69 1.119 7.5 0 7.5 0 8.059 6.382 11.25 0 14.44 0 14.999 0 15 1.117 15",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.25 15 8.75 15 8.75 12.499 15 12.499 15 10 8.75 10 8.75 7.5 6.25 7.5 6.25 10 0 10 0 12.499 6.25 12.499 6.25 15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.249 7.5 6.75 7.5 6.75 10.499 0 10.499 0 12 6.75 12 6.75 15 8.249 15 8.249 12 15 12 15 10.499 8.249 10.499 8.249 7.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.934 10.641 23.635 10.131 22.768 10.131 22.5 9.306 22.232 10.131 21.365 10.131 22.066 10.641 21.798 11.465 21.798 11.465 21.798 11.465 22.5 10.955 23.201 11.465 23.2 11.463 23.202 11.465 22.934 10.641",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.962 11.136 22.786 10.592 23.247 10.257 23.25 10.256 22.677 10.256 22.5 9.711 22.323 10.256 21.75 10.256 22.214 10.593 22.038 11.136 22.037 11.137 22.037 11.137 22.037 11.138 22.04 11.135 22.5 10.801 22.96 11.135 22.963 11.138 22.963 11.137 22.963 11.137 22.962 11.136",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.857 13.207 26.478 12.756 26.481 12.754 25.71 12.754 25.471 12.02 25.232 12.754 24.461 12.754 25.085 13.207 24.846 13.941 25.471 13.488 26.096 13.941 25.857 13.207",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.093 12.88 26.096 12.879 25.618 12.879 25.471 12.426 25.323 12.879 24.846 12.879 24.849 12.88 24.846 12.88 25.232 13.16 25.085 13.614 25.471 13.333 25.857 13.614 25.71 13.16 26.096 12.88 26.093 12.88",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.467 14.127 20.168 13.618 19.301 13.618 19.034 12.795 19.034 12.793 18.766 13.618 17.899 13.618 18.6 14.127 18.332 14.951 18.335 14.948 18.333 14.953 19.034 14.443 19.735 14.953 19.734 14.95 19.735 14.951 19.467 14.127",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.784 13.743 19.784 13.743 19.211 13.743 19.035 13.199 19.034 13.202 19.034 13.198 18.857 13.743 18.283 13.743 18.286 13.745 18.747 14.08 18.571 14.625 18.571 14.625 18.571 14.625 19.034 14.288 19.498 14.625 19.498 14.625 19.498 14.625 19.321 14.08 19.784 13.743 19.784 13.743",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.76 19.091 23.757 19.092 23.76 19.09 22.797 19.09 22.503 18.186 22.501 18.175 22.5 18.178 22.499 18.175 22.497 18.186 22.203 19.09 21.24 19.09 21.243 19.092 21.24 19.091 22.019 19.657 21.723 20.567 21.721 20.571 21.722 20.57 21.721 20.573 21.728 20.566 22.5 20.005 23.272 20.566 23.279 20.573 23.278 20.57 23.279 20.571 23.277 20.567 22.981 19.657 23.76 19.091",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.375 19.216 23.373 19.216 23.375 19.215 23.369 19.216 22.706 19.216 22.5 18.58 22.5 18.583 22.499 18.58 22.293 19.216 21.631 19.216 21.625 19.215 21.627 19.216 21.625 19.216 21.63 19.218 22.165 19.607 21.958 20.244 21.96 20.242 21.959 20.244 22.5 19.851 23.041 20.244 22.834 19.608 23.37 19.218 23.375 19.216",
    style: {
      fill: "#c8102e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/NZ.5ff344d8663c5e4edcd22610589f0ae8.svg";
export { ForwardRef as ReactComponent };